export const argentinaChilePatagoniaProgram = {
  programKey: 'argentyna-i-chile-przez-patagonie-i-ziemie-ognista',

  /* Podstawowe informacje wspólne dla sticky paska i przyszłego katalogu. */
  title: 'Argentyna i Chile - Przez Patagonię i Ziemię Ognistą',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Argentyna i Chile:',
  stickySubtitle: 'Przez Patagonię i Ziemię Ognistą',

  pageUrl:
    'https://coolturystki.pl/wycieczki/argentyna-i-chile-przez-patagonie-i-ziemie-ognista',

  /*
   * Dane wykorzystywane przez kartę programu i filtry katalogu.
   */
  catalog: {
    enabled: true,
    image:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-do-patagonii-torres-del-paine-mvb2uocm.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-do-patagonii-torres-del-paine-mvb2uocm.webp',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Argentyna i Chile'],
    continent: 'Ameryka Południowa',
    categories: [],
    travelStyles: ['Wyjazd objazdowy', 'Aktywnie', 'Egzotyka'],
    catalogPublishedAt: '2026-10-18',
  },

  /* Termin: 30 marca - 13 kwietnia 2027. */
  tripIds: [31],

  /*
   * Brak priceNote oznacza, że karta automatycznie pokaże pierwszą transzę
   * obliczoną jako 30% aktualnej ceny pobranej z Vakanzy.
   */
  termDetails: {
    '31': {
      pilotId: 'iza',
      group: 'Dla kobiet',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Lot grupowy z Warszawy',
          description:
            'Z Warszawy lecimy do Buenos Aires, a wracamy z Santiago de Chile do Warszawy. Możliwy jest także wylot z Berlina lub dolot własnym połączeniem i spotkanie z grupą na lotnisku albo w ustalonym miejscu.',
        },
        hotel: {
          title: 'Hotele 3★ i 4★ oraz domki na trasie',
          description:
            'Dwanaście noclegów spędzamy w Buenos Aires, Ushuaia, Punta Arenas, Puerto Natales i Santiago de Chile. Nocujemy w pokojach 2-osobowych oraz czteroosobowych domkach w Puerto Natales, ze śniadaniami w cenie.',
        },
      },
    },
  },
}
